export enum tipoMonedaTransformada{
  ARP = 0,
  USD = 1
}
